export async function getCurrentPositionWrapper(
  timeout: number
): Promise<GeolocationPosition> {
  return await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      // 10秒でタイムアウトになるように設定
      // ただし、errorのコールバックが呼ばれないことがあるので、setTimeoutでもタイムアウトを設定
      timeout
    });
    setTimeout(() => {
      reject(new Error("タイムアウトしました"));
    }, timeout);
  });
}
